// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".other-nav[data-v-93eadc46]{display:flex;height:64px;background-color:#111}.other-nav-logo[data-v-93eadc46]{margin-left:12px;margin-right:12px}.other-nav-left[data-v-93eadc46]{flex:4}.other-nav-right[data-v-93eadc46]{display:flex;flex-direction:row;justify-content:flex-end;align-items:center}.other-nav-right .user[data-v-93eadc46]{margin-right:24px}", ""]);
// Exports
module.exports = exports;
